<template>
  <section
    class="view-container d-flex flex-column justify-space-between mr-1 ml-1"
    style="height: calc(100vh - 10rem)"
  >
    <div>
      <v-row>
        <v-col>
          <h1>내일 매출 당겨받기</h1>
          <p>
            고객님의 미래 매출을 미리 드립니다.<br />
            먼저 받고 약 10일 간 나눠서 상환하세요.
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="detail_info">금리 : 매일 0.041%(10만원당 41원)</p>
          <p class="detail_info">상환 : 일매출의 10%씩 X 약 10일(상환시까지)</p>
          <p class="detail_info">신청 : 수시(상환이 끝나면 언제든 다시 신청 가능)</p>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row>
        <v-col cols="2">
          <v-img class="my-img" src="@/assets/images/landing/phone.png" />
        </v-col>
        <v-col cols="10" class="infobox">
          <p class="detail_info">매출 당겨받기 서비스는 아직 베타 서비스로</p>
          <p class="detail_info">지금 신청하시면 가장 먼저 이용하실 수 있도록</p>
          <p class="detail_info">상담사가 연락 드리겠습니다</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mt-0">
          <BasicButton class="basic-button--apply" @click="reqPullRevenue()"
            >매출 당겨받기 사전 신청 하기</BasicButton
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {},
  methods: {
    ...mapActions('earlyPayment', ['addEarlyPaymentsLoanRequests']),
    async reqPullRevenue() {
      await this.addEarlyPaymentsLoanRequests()
      await this.$swal.basic.alert({
        html: `신청이 완료 되었습니다.<br/>
        상담사가 바로 연락 드릴게요.`,
      })
      await this.$router.go(-1)
    },
  },
}
</script>
<style scoped>
.basic-button--apply {
  background-color: #23468d !important;
  color: #ffe15b !important;
}

h1 {
  margin-top: 2rem;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 900;
}

p {
  font-size: 0.9rem;
  line-height: 1.1rem;
}

p.detail_info {
  font-size: 0.8rem;
  line-height: 0.1rem;
  color: #999999;
}

.infobox {
  padding-top: 1rem;
}

.my-img {
  max-width: 50px;
}
</style>
